import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedHeading } from "./Reveal";
import ParallaxImage from "./ParallaxImage";
import { reservarEl } from "../lib/booking";

const servicios = [
  "Barbería premium",
  "Afeitado clásico",
  "Podología",
  "Limpiezas faciales",
  "Diseño de cejas",
  "Depilaciones",
  "Masajes descontracturantes",
  "Manicure masculina",
];

const rituales = [
  {
    nombre: "Ritual del Caballero",
    duracion: "90 min",
    img: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbHV4dXJ5JTIwYmFyYmVyc2hvcCUyMG1lbiUyMGdyb29taW5nfGVufDB8fHx8MTc4NjM5NDk4N3ww&ixlib=rb-4.1.0",
    desc: "Corte de precisión, perfilado de barba y afeitado clásico con toallas calientes. Un clásico atemporal ejecutado con maestría.",
  },
  {
    nombre: "Piel de Acero",
    duracion: "75 min",
    img: "https://images.unsplash.com/photo-1653875700329-a7c8aca94c95?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXJiZXIlMjBtZW4lMjBmYWNpYWx8ZW58MHx8fHwxNzg2Mzk0OTMzfDA&ixlib=rb-4.1.0",
    desc: "Limpieza facial profunda con exfoliación y masaje descontracturante de rostro. Diseñado para pieles exigentes y ritmos intensos.",
  },
  {
    nombre: "Reset Total",
    duracion: "110 min",
    img: "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?auto=format&fit=crop&w=800&q=75&crop=entropy&cs=srgb&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbHV4dXJ5JTIwYmFyYmVyc2hvcCUyMG1lbiUyMGdyb29taW5nfGVufDB8fHx8MTc4NjM5NDk4N3ww&ixlib=rb-4.1.0",
    desc: "Masaje corporal descontracturante, podología clínica y ritual de barbería completo. La desconexión total del hombre moderno.",
  },
];

const ExperienceEl = () => {
  return (
    <section
      id="experiencia-el"
      data-testid="section-el"
      className="relative bg-[#1a1a1a] px-6 pt-20 pb-12 md:px-16 md:pt-28 md:pb-16 grain"
    >
      <div className="relative z-10 mx-auto max-w-6xl">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div>
              <MaskedHeading
                className="font-serif-display text-[#faf9f6] text-4xl sm:text-5xl lg:text-6xl leading-none"
                lines={["Experiencia"]}
              />
              <MaskedHeading
                className="font-serif-display italic text-[#b79b7d] text-4xl sm:text-5xl lg:text-6xl leading-tight"
                lines={["Para Él"]}
                delay={0.15}
              />
            </div>
            <Reveal delay={0.24} className="mt-3">
              <p className="font-cormorant text-xl md:text-2xl italic text-[#b79b7d]">
                Cuidado con carácter
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="max-w-sm">
            <p className="text-sm md:text-base leading-relaxed text-[#cfc7c0]">
              Un espacio sobrio de charcoal y bronce: barbería, afeitado
              clásico, faciales, podología y masajes. Precisión, silencio y
              presencia en cada servicio.
            </p>
          </Reveal>
        </div>

        {/* Servicios */}
        <div className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-[#b79b7d]/25 md:grid-cols-4">
          {servicios.map((s, i) => (
            <Reveal
              key={s}
              delay={(i % 4) * 0.06}
              className="bg-[#1a1a1a] px-5 py-7 transition-colors hover:bg-[#3a3939]"
            >
              <span className="font-cormorant text-lg text-[#faf9f6] md:text-xl">
                {s}
              </span>
            </Reveal>
          ))}
        </div>

        {/* Rituales */}
        <div className="mt-8 grid gap-10 md:grid-cols-3">
          {rituales.map((r, i) => (
            <Reveal key={r.nombre} delay={i * 0.12} className="group">
              <ParallaxImage
                src={r.img}
                alt={r.nombre}
                className="h-72 rounded-2xl"
                overlay="bg-gradient-to-t from-[#111111]/60 to-transparent"
              />
              <div className="mt-6 flex items-baseline justify-between">
                <h3 className="font-serif-display text-2xl text-[#faf9f6]">
                  {r.nombre}
                </h3>
                <span className="label text-[#b79b7d]">{r.duracion}</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-[#a49a93]">
                {r.desc}
              </p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-6">
          <motion.button
            data-testid="reservar-el-btn"
            onClick={reservarEl}
            className="group inline-flex items-center gap-3 rounded-full border border-[#b79b7d] px-9 py-4 text-[#faf9f6]"
            whileHover={{ backgroundColor: "#b79b7d", color: "#1a1a1a" }}
          >
            <span className="label">Reservar para Él</span>
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </motion.button>
        </Reveal>
      </div>
    </section>
  );
};

export default ExperienceEl;
